import styled from '@emotion/styled';

export const BmiInfo = styled.div`
  display: flex;

  padding: 8px 16px;
  background: ${({ theme }) => theme.colors.greyLighter};
  border-radius: 12px;

  align-items: center;
`;
